import { IColuna } from "app/types/IColuna";
import React from "react";
import * as R from 'ramda';

const estiloCotacoesPerdidas = require("../cotacoes-perdidas.module.scss").default;

export type HeadersCotacoesPerdidasProps = {
  colunas: IColuna[];
  mostrarNomeComoCodigo: boolean
};

export const HeadersCotacoesPerdidas = (props: HeadersCotacoesPerdidasProps) => {

  const traduzirNomeColuna = ({ nomeColuna, mostraNomeCodigo }: { nomeColuna: string, mostraNomeCodigo?: boolean }) => {

    const mapColunasPesquisarProdutos = {
      "Código": mostraNomeCodigo ? "Código" : "Referência",
      "PrecoVenda": "Preço Venda",
      "PrecoConcorrente": "Preço Concorrente",
    }

    return nomeColuna in mapColunasPesquisarProdutos ? mapColunasPesquisarProdutos[nomeColuna] : nomeColuna
  }


  const estilosIndividuaisNomeColunasCotacoesPerdidas = R.cond<string[], React.CSSProperties>([
    [R.equals("Quantidade"), _ =>  ({textAlign: 'right'})],
    [R.equals("PrecoConcorrente"), _ => ({ textAlign: 'right' })],
    [R.equals("PrecoVenda"), _ => ({ textAlign: 'right' })],
  ])

 
  return (
    <div className="_table-header-group">
      <div className="_table-row">
        {props.colunas.map(
          (coluna, key) =>
            coluna.Selecionada && (
              <div
                className={`_table-cell ${estiloCotacoesPerdidas.tableCellHeader}`}
                key={key}
                style={{whiteSpace: 'normal', ...estilosIndividuaisNomeColunasCotacoesPerdidas(coluna.Nome)}}
              >
                {traduzirNomeColuna({ nomeColuna: coluna.Nome, mostraNomeCodigo: props.mostrarNomeComoCodigo })}
                {coluna.Selecionada}
              </div>
            )
        )}
      </div>
    </div>
  );
};